import type { MouseEvent } from "react";
import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-shared/uikit/Button";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";

export interface ReplaceMediaButtonProps {
  filename?: string;
  onClickRemove: (e?: MouseEvent<HTMLButtonElement>) => void;
  onClickReplace: (e?: MouseEvent<HTMLButtonElement>) => void;
  thumbnailUrl?: string;
}

export const ReplaceMediaButton = ({
  filename = "",
  thumbnailUrl = "",
  onClickReplace,
  onClickRemove,
}: ReplaceMediaButtonProps) => (
  <div className="border-primary divide-primary bg-primary flex flex-col divide-y rounded-lg border">
    {thumbnailUrl && (
      <div className="p-3">
        <img
          src={thumbnailUrl}
          alt={filename}
          loading="lazy"
          className="rounded-lg"
        />
      </div>
    )}
    <div className="flex justify-between px-3 py-2">
      <Button onClick={onClickReplace} variant="text" small>
        {t("builder_ui.prop_type.video_upload.replace")}
      </Button>
      <IconButton
        name="20-trash-bin"
        iconSize={20}
        buttonSize={28}
        className="text-dark"
        onClick={onClickRemove}
        title={t("builder_ui.prop_type.video_upload.delete")}
        ariaLabel={t("builder_ui.prop_type.video_upload.delete")}
      />
    </div>
  </div>
);
